import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-786be2a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "el-dialog__body-footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { ref, watch, nextTick } from 'vue'
import { orderRepurchase } from '@/apis/order'
import { ElMessage } from 'element-plus'
import OrderItemTable from '../OrderItemTable.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowItem: {
    type: Object,
    default: () => ({})
  },
  dataList: {
    type: Array,
    default: () => []
  }
},
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit }) {

const props = __props




watch(() => props.visible, (newValue) => {
  if (newValue) {
    toggleAll()
  }
})
const tableConfig = {
  showSelection: true,
  showExpand: true,
  rowKey: 'platformOrderItemId',
  expandConfigId: 'combinationOrderItemList',
  /** 是否可勾选 */
  // selectable: (row:any) => !(row.brandAuthStatus === 0 || row.brandStatus !== 2)
  // brandStatus为null如果不是品牌商品可以勾选
  // 品牌商品未上架允许勾选
  // 如果是品牌商品已上架且该用户已授权brandAuthStatus === 2 并且品牌商品上架中brandStatus === 2 就允许勾选
  selectable: (row:any) => row.brandStatus === '-' || row.brandHasReleased === 0 || (row.brandAuthStatus === 1 && row.brandStatus === 2)
}

const columns:any = [
  {
    label: t('店铺名称'),
    prop: 'shopName',
    align: 'center',
    width: 230,
    slotName: 'shopName'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    align: 'center',
    width: 230,
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('商品单价'),
    prop: 'actualProductSellPrice',
    align: 'center'
  }
]

const STableRef = ref()
const toggleAll = () => {
  nextTick(() => {
    STableRef.value && STableRef.value.toggleAll()
  })
}

const selectionList: any = ref([])
const handleSelection = (val: any[]) => {
  selectionList.value = val
}

const close = () => {
  emit('update:visible', false)
  selectionList.value = []
}

const submit = () => {
  if (!selectionList.value.length) return ElMessage.warning(t('请选择需要复购的商品'))
  orderRepurchase({
    platformOrderNo: props.rowItem.platformOrderNo,
    shopProductSkus: selectionList.value.map((e: any) => e.shopProductSku),
    repurchaseType: selectionList.value.length === 1 ? 1 : 2
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('复购成功'))
      close()
      emit('refresh')
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('再次下单')), 1),
      _createElementVNode("div", null, [
        _createVNode(OrderItemTable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
            STableRef.value = _value
          },
          dataList: __props.dataList,
          columns: columns,
          tableConfig: tableConfig,
          onSelectionChange: handleSelection,
          type: "repurchase"
        }, null, 8, ["dataList"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, { onClick: close }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})